export class Email {
    delivery?: EmailDelivery;
    message: {
        html: string;
        subject: string;
        attachments?: [{ filename: string, content: string }] | [{ filename: string, path: string }] | [{ path: string }] | any[];
    };
    to: string[];
    from?: { name: string, address: string }; //'"Last Name, Name" <email@from.com>'
    replyTo?: string[];
    bcc?: string[];
    attachments?: [{ filename: string, content: string }] | [{ filename: string, path: string }] | [{ path: string }] | any[];
}

// https://nodemailer.com/message/attachments/

export class EmailDelivery {
    attemps?: string;
    endTime?: any;
    error?: string;
    info?: {
        accepted?: string[];
        messageId?: string;
        pending?: string[];
        rejected?: string[];
        response: string;
    };
    leaseExpireTime: any;
    startTime: any;
    state: string;
}


export enum EmailTemplates {
    registroEmpresa = 'registro-empresa',
    generico = 'generico', // El template más comun. Tiene COMPANY, TITLE y CONTENT
}

export enum EmailTags {
    CONTENT = '===CONTENT===',
    TITLE = '===TITLE===',
    COMPANY = '===COMPANY==='
}